import { Injectable } from '@angular/core';
import { AppConfig } from '../../shared/config/app-config';
import { BVNValidationRequest, getOnboardingRequestsParam, RMOnboardingRequest } from '../../shared/models/relation-manager.model';
import { ArmWithoutDeviceResponse } from '../../shared/models/tablet-device-management.model';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { StringHelper } from '../helpers/strings.helper';

@Injectable({
  providedIn: 'root'
})
export class TabletDeviceManagementService {

  constructor(private apiClient: ApiClientHelper, public config: AppConfig) { }

  fetchTabletDevices(params: {pageNumber: number, pageSize: number, isAssigned: number})
  {
    const payload = StringHelper.toUrlString(params);
    const url = this.config.RM_ONBOARDING_URL + `/api/v1/tablets/my-tablets?${payload}`
    return this.apiClient.getForPromise(url);
  }

  getTabletDeviceById(id: number)
  {
    const url = this.config.RM_ONBOARDING_URL + `/api/v1/tablets/my-tablets/${id}`
    return this.apiClient.getForPromise(url);
  }

  fetchArmsWithoutTabletDevices()
  {
    const url = this.config.RM_ONBOARDING_URL + `/api/v1/arms/without-tablets`
    return this.apiClient.getForPromise(url);
  }

  assignTabletDevices(payload: {tabletId: number, aggregatorId: number})
  {
    const url = this.config.RM_ONBOARDING_URL + `/api/v1/arms/tablet/assign`
    return this.apiClient.patchForPromise(url, payload);
  }

  unassignTabletDevices(payload: {tabletId: number, reason: string})
  {
    const url = this.config.RM_ONBOARDING_URL + `/api/v1/tablets/unassign`
    return this.apiClient.patchForPromise(url, payload);
  }
}